import React from "react";
import { useCurrentRef } from "./use-current-ref";
import { useResizeObserver } from "./use-resize-observer";

const Getters = {
  width: (entry: ResizeObserverEntry) =>
    entry.contentRect.width ? `${entry.contentRect.width}px` : undefined,
  height: (entry: ResizeObserverEntry) =>
    entry.contentRect.height ? `${entry.contentRect.height}px` : undefined,
};

export const useCssObserver = ({
  target,
  storage = target,
  mapper,
  // debug,
}: {
  target: React.MutableRefObject<HTMLElement | null>;
  storage?: React.MutableRefObject<HTMLElement | null>;
  mapper?: {
    [k: string]:
      | ((v: ResizeObserverEntry) => string | null | undefined)
      | keyof typeof Getters;
  };
  // debug?: boolean;
}) => {
  const mapperRef = useCurrentRef(mapper);
  return useResizeObserver(target, (entry) => {
    if (!storage.current || !mapperRef.current) return;
    for (const [key, _getter] of Object.entries(mapperRef.current)) {
      const getter = typeof _getter === "string" ? Getters[_getter] : _getter;
      const value = getter(entry);
      if (value === null) {
        storage.current.style.removeProperty(key);
      } else if (value !== undefined) {
        storage.current.style.setProperty(key, value);
      }
    }
  });
};
